module.exports = "<template> <div id=sio-paticipants-list></div> </template>";